import {createSlice} from '@reduxjs/toolkit';
import {fetchAvailableEmployeeList} from '../actions/EmployeeActions';

const EmployeeSlice = createSlice({
  name: 'employee',
  initialState: {
    availableEmployeeList: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
  },
  reducers: {
    setEditModalEmployees: (state, action) => {
      const {employeeId, employeeName} = action.payload;
      state.availableEmployeeList.data.push({
        employeeId,
        employeeName,
        isSelected: true,
      });
    },
    clearSelectedEmployee: (state) => {
      state.availableEmployeeList.data =
        state.availableEmployeeList.data.filter((item) => !item.isSelected);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAvailableEmployeeList.pending, (state) => {
        state.availableEmployeeList.status = 'loading';
      })
      .addCase(fetchAvailableEmployeeList.fulfilled, (state, action) => {
        state.availableEmployeeList.status = 'idle';
        state.availableEmployeeList.data = action.payload.result;
      })
      .addCase(fetchAvailableEmployeeList.rejected, (state, action) => {
        state.availableEmployeeList.status = 'rejected';
        state.availableEmployeeList.error = action.error.message;
      });
  },
});

export default EmployeeSlice.reducer;
export const {setEditModalEmployees, clearSelectedEmployee} =
  EmployeeSlice.actions;
